import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { usePageTitle } from "@/hooks/usePageTitle";
import { TranscriptsProvider } from "@/components/transcripts/TranscriptsProvider";
import { TranscriptsPage } from "@/components/transcripts/TranscriptsPage";

const Transcripts = () => {
	const { t } = useTranslation();
	usePageTitle(t("transcripts.title", "Transcripts"));

	return (
		<TranscriptsProvider variant="page">
			<div className="flex h-full min-h-0 flex-col p-4 md:pb-6 md:pl-12 md:pr-6 md:pt-1">
				<PageHeader title={t("transcripts.title", "Transcripts")} className="mb-4 shrink-0" />
				<div className="min-h-0 flex-1 overflow-hidden rounded-sm border border-border bg-background shadow-card">
					<TranscriptsPage />
				</div>
			</div>
		</TranscriptsProvider>
	);
};

export default Transcripts;
